<style>
  .clearfix:after {
    content: '';
    display: block;
    visibility: hidden;
    clear: both;
  }
  .select-container {
    padding: 15px 2% 3px;
  }
  .select-left {
    float: left;
    display: table;
  }
  .select-left > div {
    vertical-align: top;
  }
  .select-left > div:not(:last-child) {
    margin-right: 5px;
  }
  .select-right {
    float: right;
  }
</style>

<template>
  <div>
    <div class="select-container clearfix" style="margin-top: 2%;margin-left: 2%;float: left;">
    <span style="font-size:38px;font-weight:bold;">其它 FAQ</span><br><br><br>
    <span style="font-size:30px;font-weight:bold;">1、如何判断是否成功安装MOA</span><br><br>
    <p>MOA安装完成后，首次运行需要<span style="color:red">使用自己的手机大象扫码</span>，在看到类似如下的MOA界面后，说明安装成功。</p>
    <p><img src="../assets/other_FAQ/other_FAQ_pic01.png" width=600px height=370px></p>
    <span style="font-size:30px;font-weight:bold;">2、提供给6000同学安装状态查询接口</span><br><br>
    <p>安装状态查询接口：<a data-auto_update="0" data-pageid="" style="color:#1890ff" href="https://report-mon.sankuai.com/report/api/check_status?mis_id=wangzepeng05" class="ct-link" target="_blank" rel="noopener">https://report-mon.sankuai.com/report/api/check_status?mis_id=wangzepeng05</a></p>
    <p><img src="../assets/other_FAQ/other_FAQ_pic02.png" width=1000px height=80px></p>
    <span style="font-size:30px;font-weight:bold;">3、如何修改MOA绑定的mis号</span><br><br>
    <p><span style="color:red">当前不支持mis号修改</span>，所以一定要提醒同事安装时<span style="color:red">用自己的手机大象扫码</span>。</p>
    <span style="font-size:30px;font-weight:bold;">4、申请MOA白名单条件及申请流程</span><br><br>
    <p>MOA不支持的系统：Windows xp、Linux（Ubuntu等）</p>
    <p>申请流程：如工作需要，不能从Windows XP 升级到Windows 7或Windows 10，可参考<a data-auto_update="0" data-pageid="64163063" style="color:#1890ff" href="https://km.sankuai.com/page/64163063" class="ct-link" target="_blank" rel="noopener">MOA/DLP白名单申请流程</a> 。</p>
    <p>说明：因为微软已不维护Windows XP、Windows 2003、Windows 8系统，即将不支持维护Windows 10，所以<strong>如果这些系统曝出存在新的漏洞，微软也不会对这些系统提供安全补丁</strong>，存在很大的安全风险。对Windows用户，我们<strong>强烈建议使用Windows10系统进行办公</strong>。</p>
    <span style="font-size:30px;font-weight:bold;">5、临时不安装MOA的条件及申请流程</span><br><br>
    <p>临时条件：产假、长期病假</p>
    <p>流程：请提交名单列表给信息安全部 jijuntao、pengzhengmao、wangzepeng05。</p>
    <p>说明：员工在返回岗位后，仍然需要安装MOA，否则<strong>会影响对公司办公网络和业务系统的正常访问，影响员工正常办公</strong>。</p>
    <span style="font-size:30px;font-weight:bold;">6、正在申请离职的员工是否可以不安装或是否可以申请白名单？</span><br><br>
    <p><span style="color:red">a、严禁正在申请离职的员工申请MOA和DLP白名单。</span></p>
    <p>b、如已提交离职申请，但是工作交接还有一周以上的员工，<span style="color:red">仍需安装MOA和DLP。</span></p>
    <span style="font-size:30px;font-weight:bold;">7、私人电脑是否需要安装公司MOA？</span><br><br>
    <p>私人电脑如果用于正常办公，就需要安装公司的MOA。比如:有些同事的公司电脑、私人电脑都用于正常办公，那两台电脑都需要安装MOA。</p>
    <span style="font-size:30px;font-weight:bold;">8、如果MOA被其他同事扫码，该怎么处理？</span><br><br>
    <p>说明：参考FAQ 3</p>
    <p>解决方法：将 当前同事 及 扫码同事 的mis号提交给 信息安全部 jijuntao、pengzhengmao、wangzepeng05 处理。</p>
    <span style="font-size:30px;font-weight:bold;">9、使用了已离职同事的电脑，MOA已安装好，该怎么处理？</span><br><br>
    <p>将 当前同事 及 已离职同事 的mis号提交给信息安全部 jijuntao、pengzhengmao、wangzepeng05 处理。</p>
    <span style="font-size:30px;font-weight:bold;">10、非电脑设备用于办公，如手机、pad等，是否需要安装MOA？</span><br><br>
    <p>MOA目前支持Windows 7，Windows 10及苹果电脑部署，暂不支持移动端部署。</p>
    <p>解决办法：由当事人领导提供名单列表，联系信息安全部 jijuntao、pengzhengmao、wangzepeng05 处理。</p>
    <span style="font-size:30px;font-weight:bold;">11、MOA阻断策略上线后，被限制访问处理方法</span><br><br>
    <p>a、用户被阻断策略阻断后，会出现如下限制访问提示页面，根据提示检查自己电脑上MOA和DLP的安装和运行状态。</p>
    <p><img src="../assets/other_FAQ/other_FAQ_pic03.png" width=900px height=500px></p>
    <p>b、针对不能立即安装MOA，但是又需要访问内部系统的用户，建议走临时白名单申请，请参考限制访问提示页面中白名单申请：【MOA: <a data-auto_update="0" data-pageid="" style="color:#1890ff" href="https://reg-sec.meituan.com/moa/bypass?token=moa" class="ct-link" target="_blank" rel="noopener">https://reg-sec.meituan.com/moa/bypass?token=moa</a> 】临时申请白名单。</p>
    <p><img src="../assets/other_FAQ/other_FAQ_pic04.png" width=700px height=110px></p>
    <p>c、请注意，白名单时效为四小时，四小时后就时效，请及时安装MOA。白名单只允许申请三次。</p>
    <p><img src="../assets/other_FAQ/other_FAQ_pic05.png" width=750px height=370px></p>
    <p>d、用户完成安装MOA后，由于MOA数据同步需要10分钟左右，建议可先自行申请临时白名单保证当前可正常访问网络，再安装MOA。</p>
    <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;白名单生效时间为五分钟，生效后，关闭浏览器所有页面后再重新打开需要访问的内部系统即可。</p>
    <span style="font-size:30px;font-weight:bold;">12、MOA已安装，仍被限制访问，如何解决？</span><br><br>
    <p>a、判断大象扫码登录或申请白名单时间，以上生效时间分别为10分钟（MOA安装），5分钟（白名单申请）。</p>
    <p>b、查询mis号安装状态:<a data-auto_update="0" data-pageid="" href="https://report-mon.sankuai.com/report/api/check_status?mis_id=wangzepeng05" style="color:#1890ff" class="ct-link" target="_blank" rel="noopener">https://report-mon.sankuai.com/report/api/check_status?mis_id=wangzepeng05</a> ，查看MOA和DLP的安装状态，是否DLP未正常安装。</p>
    <p>c、如果MOA安装时间，或者白名单申请时间已超过正常时间，MOA安装状态仍然是“N”，请联系信息安全部 wangzepeng05、jijuntao、pengzhengmao。</p>
    <p>d、如果mis号查询MOA安装状态为“Y”，员工仍被限制访问，请员工重启系统，重新打开Chrome浏览器，使用无痕模式尝试访问。</p>
    <p><img src="../assets/other_FAQ/other_FAQ_pic06.png" width=250px height=300px></p>
    <p>e、彻底解决无法登陆的问题，请清除浏览器Cookie，具体方法可参考：</p>
    <p><a data-auto_update="0" href="https://jingyan.baidu.com/article/09ea3ede4a4127c0aede39a7.html" style="color:#1890ff" class="ct-link" target="_blank" rel="noopener">https://jingyan.baidu.com/article/09ea3ede4a4127c0aede39a7.html</a></p>
    <span style="font-size:30px;font-weight:bold;">13、覆盖安装未跳出签署协议</span><br><br>
    <p>默认该电脑签署过一次MOA用户协议后，覆盖安装或升级，不会再跳出签署用户协议页面。</p>
    <p>除非彻底卸载MOA后的安装，才会跳出签署用户协议页面。</p>
    <span style="font-size:30px;font-weight:bold;">14、拒绝签署“安全管理客户端用户协议”</span><br><br>
    <p>拒绝签署“安全管理客户端用户协议”，则表示退出MOA，MOA未正常运行，该电脑将无法登陆SSO，影响正常办公。</p>
    <p><img src="../assets/other_FAQ/other_FAQ_pic07.png" width=900px height=630px></p>
    <span style="font-size:30px;font-weight:bold;">15、MOA版本过旧导致更新失败</span><br><br>
    <p>MOA版本过旧在更新时会有更新失败的问题，请直接下载最新稳定版MOA进行覆盖安装即可。</p>
    <span style="font-size:30px;font-weight:bold;">16、已安装最新版本MOA，仍然被限制访问</span><br><br>
    <p>如果当前检测MOA已经是最新版本，但仍然被限制访问。请重启电脑后再尝试访问内网。</p>
    </div>
  </div>
</template>

<script>
  import store from '../vuex/service/store'
  import axios from 'axios'
  import {mapState} from 'vuex';
  import util from '../views/util/commonUtil'

  export default {
    store: store,
    mounted: function () {
      var vm =this;
      if(vm.token == ""){
        var token = this.getCookie("access-token");
        if(token != null){
          vm.$store.commit('UPDATETOKEN',token);
          vm.token = token;
        }
      }
      vm.getUser();
    },
    computed: mapState({
      loginRediret: function (state) {
        return state.loginRediret;
      },
      cookieName: function (state) {
        return state.cookieName;
      },
      getuserAPI: function (state) {
        return state.getuserAPI;
      }
    }),
    filters: {
      idcExplain(val) {
        return util.idcExplain(val)
      },
      timeFormat(val) {
        return util.timeFormat(val)
      },
      switchColor(val) {
        return util.switchColor(val)
      },
      statusExplain(val) {
        return util.statusExplain(val)
      }
    },
    methods: {
      reset() {

      },
      kmUrl(URL){
        window.open(URL);
      },
      routerUrl(URL){
        this.$router.push(URL)
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      getCookie(name){
        var arr,reg=new RegExp("(^| )"+name+"=([^;]*)(;|$)");
        if(arr=document.cookie.match(reg))
          return unescape(arr[2]);
        else
          return null;
      },
      getUser() {
        var vm = this;
        if (vm.user == null || vm.user == "") {
          vm.user = vm.getCookie("username");
          document.cookie="ssoid="+vm.getCookie("access-token");
          axios.get(vm.getuserAPI, {
            withCredentials: true
          }).then((response) => {
            if(response.data.status==401){
               document.cookie = vm.cookieName + vm.$route.fullPath;
               window.location = vm.loginRediret;
            }

          }).catch(function (error) {
            vm.requesterrorinfo(error)
          })
        }
      },
      requesterrorinfo(error){
        var vm =this;
        if (error.response) {
          var code = error.response.status;
          if (code == 401) {
            vm.$message.error("401:您未登录");
            var count = vm.getCookie("access-count")
            window.location = vm.loginRediret;
            if(count==null || count==0){
              document.cookie="access-count=1";
              vm.$message('您未登录,请刷新');
              document.cookie = vm.cookieName + vm.$route.fullPath;
              window.location = vm.loginRediret;
            }else{
              vm.$message('您未登录,请刷新');
            }
          } else {
            if (code == 404) {
              vm.$notify({
                title: '提示',
                message: '404:Not found!',
                type: 'error'
              });
            } else {
              vm.$notify({
                title: '提示',
                message: '501:服务端未响应!',
                type: 'error'
              });
            }
          }
        } else {
          vm.$notify({
            title: '提示',
            message: '502:服务端未响应!',
            type: 'error'

          });
        }
      }
    },
    data() {
      return {
        hostname:'',
        token:'',
      }
    }
  }
</script>
<style>
  .select1 {
    width: 100px;
  }
  .select2 {
    width: 130px;
  }
  .select3 {
    width: 160px;
  }
  .input1 {
    width: 350px;
  }
  .input2 {
    width: 210px;
  }
  .demo-table-expand label {
    width: 140px;
    color: #5d94bf;
  }
</style>



// WEBPACK FOOTER //
// other_FAQ.vue?1fb375c4